export default __webpack_public_path__ + "static/media/price_list.5441ee4d.svg";